// apiServices/authService.js
import axios from 'axios';
import { BASE_URL } from '../services/APIs';

// Simple axios instance
export const api = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

